import { graphql, useStaticQuery } from 'gatsby'
import { SanityTermsQuery } from '../../../graphql/gatsby'
import { SanityTermsType } from '../types'

export type UseSanityTerms = SanityTermsQuery['allSanityTerms']['nodes'][number] | undefined

export const useSanityTerms = (termsType: SanityTermsType): UseSanityTerms => {
  const { allSanityTerms } = useStaticQuery<SanityTermsQuery>(
    graphql`
      query SanityTerms {
        allSanityTerms(sort: { fields: _updatedAt, order: DESC }) {
          totalCount
          nodes {
            _type
            _id
            identifier
            title
            lastModified
            _rawContent(resolveReferences: { maxDepth: 100 })
          }
        }
      }
    `
  )
  return allSanityTerms.nodes.find((node) => node.identifier === termsType)
}
